import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { deleteNotification } from "../../../../features/notifications/notificationThunks";
import { clearSelected } from "../../../../features/notifications/notificationSlice";

const NotificationDetail = () => {
  const dispatch = useDispatch();
  const { selected } = useSelector((state) => state.notifications);

  if (!selected) return null;

  const handleClose = () => dispatch(clearSelected());

  // Placeholder image if none exists
  const imageUrl = selected.image 
    ? `${process.env.REACT_APP_IMAGE_BASE_URL.replace(/\/$/, "")}${selected.image}`
    : "https://via.placeholder.com/600x400?text=No+Image+Available";

  return (
    <div className="modal-overlay" onClick={handleClose}>
      <div className="notification-card" onClick={(e) => e.stopPropagation()}>
        <button className="close-icon" onClick={handleClose} aria-label="Close">
          ✕
        </button>

        <div className="notification-image-container">
          <img
            src={imageUrl}
            alt={selected.title}
            className="notification-hero-image"
          />
        </div>

        <div className="notification-content">
          <div className="content-header">
            <span className="badge">Notification</span>
            <small className="timestamp">
              {new Date(selected.createdAt).toLocaleDateString(undefined, {
  weekday: "long",
  year: "numeric",
  month: "long",
  day: "numeric"
})}
{" at "}
{new Date(selected.createdAt).toLocaleTimeString(undefined, {
  hour: "2-digit",
  minute: "2-digit",
  hour12: true
})}

            </small>
          </div>

          <h3 className="notification-title">{selected.title}</h3>
          
          <div className="notification-body">
            <p>{selected.message}</p>
          </div>

          <div className="notification-actions">
            <button
              className="btn-delete"
              onClick={() => dispatch(deleteNotification(selected._id))}
            >
              <span className="icon">🗑️</span> Delete
            </button>
            <button className="btn-secondary" onClick={handleClose}>
              Dismiss
            </button>
          </div>
        </div>
      </div>
      <style>{`
      /* Backdrop Overlay */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(4px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 20px;
  animation: fadeIn 0.3s ease;
}

/* Modal Card */
.notification-card {
  margin-top: 4rem;
  background: #ffffff;
  width: 100%;
  max-width: 500px;
  border-radius: 16px;
  overflow: hidden;
  position: relative;
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
  animation: slideUp 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
}

/* Close Button */
.close-icon {
  position: absolute;
  top: 12px;
  right: 12px;
  background: rgba(255, 255, 255, 0.8);
  border: none;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  cursor: pointer;
  z-index: 10;
  font-weight: bold;
  transition: background 0.2s;
}

.close-icon:hover {
  background: #ff4d4d;
  color: white;
}

/* Image Section */
.notification-image-container {
  width: 100%;
  height: 350px;
  background: #f3f4f6;
}

.notification-hero-image {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

/* Content Section */
.notification-content {
  padding: 24px;
}

.content-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
}

.badge {
  background: #eff6ff;
  color: #3b82f6;
  padding: 4px 10px;
  border-radius: 99px;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
}

.timestamp {
  color: #6b7280;
  font-size: 13px;
}

.notification-title {
  margin: 0 0 12px 0;
  font-size: 1.5rem;
  color: #1f2937;
  font-weight: 700;
}

.notification-body {
  color: #4b5563;
  line-height: 1.6;
  font-size: 15px;
  margin-bottom: 24px;
  max-height: 200px;
  overflow-y: auto;
  white-space: pre-line;
}

/* Action Buttons */
.notification-actions {
  display: flex;
  gap: 12px;
}

.btn-delete {
  flex: 2;
  background: #fee2e2;
  color: #dc2626;
  border: none;
  padding: 12px;
  border-radius: 8px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
}

.btn-delete:hover {
  background: #dc2626;
  color: white;
}

.btn-secondary {
  flex: 1;
  background: #f3f4f6;
  color: #4b5563;
  border: none;
  padding: 12px;
  border-radius: 8px;
  font-weight: 600;
  cursor: pointer;
}

/* Animations */
@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

@keyframes slideUp {
  from { transform: translateY(20px); opacity: 0; }
  to { transform: translateY(0); opacity: 1; }
}

/* Responsive adjustments */
@media (max-width: 480px) {
  .notification-card {
    max-width: 100%;
    border-radius: 12px;
  }
  
  .notification-image-container {
    height: 180px;
  }

  .notification-title{
    font-size: 0.8rem;
  }

  .notification-actions {
    flex-direction: column;
  }
}
      `}</style>
    </div>
  );
};

export default NotificationDetail;